<template>
  <div class="chips" v-if="tvaMq === 'desktop'">
    <span class="chips__label">{{ label }}</span>
    <div class="chips__wrapper">
      <button
        v-for="category in categories"
        :key="category.label"
        :class="[
          'chips__wrapper__category',
          {
            disable:
              $route.query.category &&
              $route.query.category !==
                category.value.replace(/\s/g, '').toLowerCase(),
          },
        ]"
        @click="changeCategory(category.value)"
      >
        <p
          class="chips__wrapper__category__dot"
          :style="{
            backgroundColor: category.color,
          }"
        ></p>
        {{ category.label }}
      </button>
    </div>
  </div>
  <div v-else class="chips">
    <button
      class="chips__button"
      :aria-label="$t('general.cta.openFilters')"
      @click="setModalOpen"
    >
      <icon :data="pageIcons[icon]"></icon>
    </button>
    <Transition name="slide-down-filter">
      <ModalFilters
        :icon="iconClose"
        :categories="categories"
        :label="labelModal"
        @closeModal="setModalOpen"
        @changeCategory="changeCategory"
        v-if="openFilterModal"
      />
    </Transition>
  </div>
</template>

<script setup>
import { inject, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { pageIcons } from "../../../plugins/page-icons";
import ModalFilters from "./ModalFilters.vue";

const tvaMq = inject("$tvaMq");

const router = useRouter();
const route = useRoute();

const openFilterModal = ref(false);

defineProps({
  categories: Array,
  label: String,
  labelModal: String,
  icon: String,
  iconClose: String,
});

const changeCategory = (value) => {
  if (route.query.category === value.replace(/\s/g, "").toLowerCase())
    return router.replace({
      query: { ...route.query, category: undefined },
    });
  router.push({
    path: "/",
    query: { ...route.query, category: value.replace(/\s/g, "").toLowerCase() },
  });
};

const setModalOpen = () => {
  openFilterModal.value = !openFilterModal.value;
};
</script>

<style lang="scss" scoped>
.chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;

  &__label {
    @include label-filter;
    margin-right: toRem(12);
  }

  &__wrapper {
    display: flex;
    &__category {
      border: 1px solid $scala-grigi-gray-3;
      border-radius: toRem(50);
      display: flex;
      align-items: center;
      padding: toRem(6) toRem(8) toRem(6) toRem(12);
      transition: all 0.3s ease;
      @include title-h-6;
      margin-right: toRem(12);
      height: toRem(30);

      &__dot {
        width: toRem(18);
        height: toRem(18);
        border-radius: 100%;
        margin-right: toRem(10);
      }

      &.disable {
        color: $scala-grigi-gray-3;
        border-color: $scala-grigi-gray-2;
        opacity: 0.3;

        .chips__category__dot {
          background-color: $scala-grigi-gray-3 !important;
        }
      }

      &:hover:is(.disable) {
        border-color: $primary-yellow;
        @include chip-bottom-timeline;
      }
    }
  }

  &__button {
    width: toRem(36);
    height: toRem(36);
    border-radius: 100%;
    border: 1px solid $scala-grigi-gray_2;
    display: flex;

    & > svg {
      margin: auto;
    }
  }
}
</style>
